module.exports = __webpack_public_path__ + "static/media/save.b179a6a9.svg";